import { render, staticRenderFns } from "./EventMiddleScreen.vue?vue&type=template&id=b6d50468&"
import script from "./EventMiddleScreen.vue?vue&type=script&lang=js&"
export * from "./EventMiddleScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventMiddleScreen.vue"
export default component.exports